<template>
  <div class=" module-reg">
    <div class="main">
      <div class="phone input-bg">
        <div class="inpuy-style">
          <input
            type="text"
            autocomplete="off"
            :placeholder="phonePlaceholder"
            v-model="account"
            class="input-p-w"
            @keyup="inputMobile"
            @paste="inputMobile"
            ref="mobile"
            oninput="value=value.replace(/[^\d]/g,'')"
          />
        </div>
        <img
          src="../../assets/img/layer2/code-btn.png"
          alt=""
          srcset=""
          class="code-btn btn"
          v-if="timeTrue"
          @click="start_reg(1)"
        />
        <div class=" btn" v-else>
          <div class="code-countdown-btn" v-if="time > 0">
            <!-- 발송됨({{ time }}) -->
            <img
              src="../../assets/img/layer2/countdown-btn.png"
              alt=""
              srcset=""
              class=" "
            />
            <span class="time-s">({{ time }}S)</span>
          </div>
          <img
            src="../../assets/img/layer2/reset-btn.png"
            alt=""
            srcset=""
            v-else
            @click="start_reg(2)"
          />
        </div>
      </div>
      <div class="code input-bg">
        <div class="inpuy-style">
          <input
            type="text"
            class="input-p-w"
            maxlength="6"
            autocomplete="off"
            placeholder="인증번호 입력"
            v-model="captchaVal"
            oninput="value=value.replace(/[^\d]/g,'')"
          />
          <img
            src="../../assets/img/layer2/sub-btn.png"
            alt=""
            srcset=""
            class="sub-btn btn"
            @click="handleSubscribe()"
          />
        </div>
      </div>

      <div class="checkbox-position">
        <div class=" position-relative cursor" @click="handlePolicy">
          <img
            src="../../assets/img/layer2/c-active.png"
            class="c-checkbox"
            v-if="policy"
          />
          <img src="../../assets/img/layer2/c.png" class="c-checkbox" v-else />
          <img src="../../assets/img/layer2/p-1.png" class="p-1 p-position" />
        </div>
        <div class=" position-relative c-h cursor">
          <div @click="handlePolicyOther('1')">
            <img
              src="../../assets/img/layer2/c-active.png"
              class="c-checkbox"
              v-if="policyA"
            />
            <img
              src="../../assets/img/layer2/c.png"
              class="c-checkbox"
              v-else
            />
            <img src="../../assets/img/layer2/p-2.png" class="p-2 p-position" />
          </div>
          <img
            src="../../assets/img/layer2/link-txt.png"
            class="p-position"
            @click="handlePModel('pup-top')"
          />
        </div>
        <div class=" position-relative c-h cursor">
          <div @click="handlePolicyOther('2')">
            <img
              src="../../assets/img/layer2/c-active.png"
              class="c-checkbox"
              v-if="policyB"
            />
            <img
              src="../../assets/img/layer2/c.png"
              class="c-checkbox"
              v-else
            />
            <img src="../../assets/img/layer2/p-3.png" class="p-3 p-position" />
          </div>
          <img
            src="../../assets/img/layer2/link-txt.png"
            class="p-position"
            @click="handlePModel('pup-bottom')"
          />
        </div>
      </div>

      <div class="btn-b">
        <img
          src="../../assets/img/layer2/gg.png"
          alt=""
          srcset=""
          @click="handleGG('gp')"
        />
        <img
          src="../../assets/img/layer2/ios.png"
          alt=""
          srcset=""
          @click="handleIOS('ios')"
        />
        <img
          src="../../assets/img/layer2/os.png"
          alt=""
          srcset=""
          @click="handleOS('os')"
        />
      </div>
    </div>

    <!-- 用户协议 -->
    <div class="model reg-model p-user" v-if="puserModel">
      <div class="cnt">
        <img
          src="../../assets/img/layer2/close.png"
          alt=""
          srcset=""
          class="close"
          @click="handlePModel('3')"
        />
        <img
          :src="require('../../assets/img/layer2/' + pupSrc + '.png')"
          alt=""
          srcset=""
          class="p-up"
        />
      </div>
    </div>

    <!-- 预注册错误码弹出框 -->
    <div class="model reg-model p-errCode" v-if="errModel">
      <div class="cnt reg-cnt">
        <img
          src="../../assets/img/layer2/close.png"
          alt=""
          srcset=""
          class="close"
          @click="handleCodeClose()"
        />
        <img
          :src="require('../../assets/img/layer2/code' + errCode + '.png')"
          alt=""
          srcset=""
          class="p-regcode"
          @click="handleCodeClose()"
        />
      </div>
    </div>
  </div>
</template>
<script>
import reg from "./reg.vue";

export default {
  components: {
    reg
  },
  name: "app",

  data() {
    return {
      phonePlaceholder: "'010'과 '-'을 제외한 휴대폰 번호 입력", // 输入手机号
      codePlaceholder: "인증번호 입력", // 获取验证码
      account: "",
      captchaVal: "", // 验证码
      timeTrue: true,
      time: 0,
      policy: false,
      policyA: false,
      policyB: false,
      puserModel: false,
      errModel: false,
      errCode: 0, //错误码
      pupSrc: "pup-top"
    };
  },
  watch: {},
  created() {},
  methods: {
    handleGG(val) {
      this.common.goShare(val);
    },
    handleIOS(val) {
      // this.common.goShare(val);
      alert("기대해주세요!");
    },
    handleOS(val) {
      this.common.goShare(val);
    },
    handlePModel(val) {
      this.pupSrc = val;
      this.puserModel = !this.puserModel;
      this.$emit("handleFIndex", this.puserModel);
    },
    hidePModel() {},
    handlePolicy() {
      this.policy = !this.policy;
      if (this.policy) {
        this.policyA = true;
        this.policyB = true;
      } else {
        this.policyA = false;
        this.policyB = false;
      }
    },
    handlePolicyOther(val) {
      if (val == 1) {
        this.policyA = !this.policyA;
      } else if (val == 2) {
        this.policyB = !this.policyB;
      }
      if (this.policyA && this.policyB) {
        this.policy = true;
      } else {
        this.policy = false;
      }
    },
    inputMobile(e) {
      this.formatMobile(e);
      this.account = this.$refs.mobile.value;
    },
    formatMobile(e) {
      let val = this.$refs.mobile.value; // 不可直接用this.mobile，第一方便提取该方法降低代码耦合度，第二直接用this.mobile,在输入汉字时按下shift按键会导致无法再输入和删除内容
      let selStart = this.$refs.mobile.selectionStart; // 选中区域左边界位置
      let mobileLen = val.length;

      let value = this.getValue(e, val).substr(0, 8); // 获取输入/粘贴内容,并截取前11位
      let len = value.length;
      if (len > 4 && len < 7) {
        value = value.replace(/^(\d{4})/g, "$1-");
      } else if (len >= 7) {
        value = value.replace(/^(\d{4})(\d{4})/g, "$1-$2");
      }
      this.$refs.mobile.value = value;
      if (selStart !== mobileLen) {
        if (selStart === 4) {
          selStart++;
        }
        // 设置光标位置
        this.$refs.mobile.selectionStart = this.$refs.mobile.selectionEnd = selStart;
      }
    },
    getValue(e, val) {
      let value = "";
      if (e.type === "keyup") {
        value = val.replace(/\D/g, "");
      } else if (e.type === "paste") {
        let clipboardData = event.clipboardData || window.clipboardData;
        value = clipboardData.getData("Text"); // 获取剪贴板text格式的数据
        value = value.replace(/\D/g, "");
      }
      return value;
    },
    //  end
    inputFocus() {
      //   this.pfFlag = true;
      //   this.phonePlaceholder = "";
    },
    start_reg(val) {
      gtag("event", "start_reg");
      if (val == 1) {
        this.handleGetCode();
      } else if (val == 2) {
        this.acquire();
      }
    },
    handleGetCode() {
      this.$emit("handleFIndex", true);
      const account = this.account.replace("-", "");
      if (account.toString().length !== 8 || isNaN(Number(account))) {
        this.errModel = true;
        this.errCode = 1;
      } else if (!this.policy) {
        this.errModel = true;
        this.errCode = 2;
      } else {
        this.$emit("handleFIndex", false);
        this.acquire();
        this.handleSms();
      }
    },
    handleCodeClose() {
      this.$emit("handleFIndex", false);
      this.errModel = false;
      if (this.errCode == 5) {
        this.account = "";
        this.captchaVal = "";
        this.time = true;
        this.time = 0;
        this.policy = false;
        this.policyA = false;
        this.policyB = false;
      }
    },
    acquire() {
      this.timeTrue = false;
      this.time = 60;
      var setTimeoutS = setInterval(() => {
        this.time--;
        if (this.time <= 0) {
          clearInterval(setTimeoutS);
          this.timeTrue = true;
        }
      }, 1000);
    },
    // 验证码接口
    handleSms() {
      // 获取验证码接口
      const account = this.account.replace(/-/g, "");
      const reqTime = Math.floor(new Date().getTime() / 1000);
      // 计算signature
      const params = {
        code: 82,
        mobile: "010" + account,
        game: 461
      };

      this.$axios({
        method: "post",
        url: "sms",
        data: {
          signature: this.common.makeSignature(params, reqTime),
          reqTime: reqTime,
          code: 82,
          mobile: "010" + account,
          game: 461
        },
        //withCredentials:true, //局部携带cookie
        headers: {} //如果需要添加请求头可在这写
      })
        .then(res => {
          if (res.data.code === 0) {
          } else {
          }
        })
        .catch(err => {});
    },
    // 预注册接口
    handleSubscribe() {
      gtag("event", "complete_reg");
      const account = this.account.replace(/-/g, "");

      const reqTime = Math.floor(new Date().getTime() / 1000);
      let source = "unknow";
      let target = "unknow";
      let share = "unknow";
      let url = window.location.search;

      let shareParam =
        url.indexOf("share") >= 0
          ? this.common.getUrlParam("share").slice(0, -2)
          : this.common.getUrlParam("share");

      source = this.common.getUrlParam("source") || "unknow";
      target = this.common.getUrlParam("target") || "unknow";
      share = shareParam || "unknow";
      // 计算signature
      const params = {
        account: "010" + account,
        game: 461,
        type: 0
      };

      this.$emit("handleFIndex", true);
      if (account.toString().length !== 8 || isNaN(Number(account))) {
        this.errModel = true;
        this.errCode = 1;
      }
      if (this.captchaVal.toString().length !== 6) {
        this.errModel = true;
        this.errCode = 4;
      }
      if (!this.policy) {
        this.errModel = true;
        this.errCode = 2;
      } else {
        this.$axios({
          method: "post",
          url: "flower/subscribe",
          data: {
            signature: this.common.makeSignature(params, reqTime),
            reqTime: reqTime,
            account: "010" + account,
            game: 461,
            code: 82,
            captcha: this.captchaVal,
            source: source,
            target: target,
            type: 0
          },
          //withCredentials:true, //局部携带cookie
          headers: {} //如果需要添加请求头可在这写
        })
          .then(res => {
            if (res.data.code === 0) {
              if (Number(res.data.data.isNew) === 0) {
                // this.regCode = 1;
              } else {
                // this.regCode = 5;
              }
              this.errModel = true;
              this.errCode = 5;
            } else {
              this.errModel = true;
              this.errCode = 6;
            }
          })
          .catch(err => {});
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.module-reg {
  .screen-container {
    width: 100%;
    position: relative;
  }
  .main {
    input[type="text"] {
      display: inline-block;
      font-size: 16px;
      font-family: KozMinStd-Bold;
      font-weight: bold;
      font-stretch: normal;
      letter-spacing: 2px;
      color: #3c3c3c;
      background: transparent;
      height: 63px;
      line-height: 63px;
    }

    input::placeholder {
      color: #3c3c3c;
    }
    .input-bg {
      width: 385px;
      height: 63px;
      background: url("../../assets/img/layer2/inpuy-style.png") no-repeat;
      background-size: 100% 100%;
      position: relative;
      margin-bottom: 1vw;
      .inpuy-style {
        width: 385px;
        height: 63px;
        .input-p-w {
          width: 100%;
          text-align: center;
        }
      }
      .btn {
        height: auto;
        width: 165px;
        position: absolute;
        right: -165px;
        top: 0;
      }
      img {
        height: auto;
        width: 165px;
        position: absolute;
        top: 0;
      }
      .code-countdown-btn {
        position: relative;
        height: 63px;

        .time-s {
          font-size: 22px;
          font-weight: bold;
          color: #ffffffd1;
          position: absolute;
          right: 1.6vw;
          top: 48%;
          transform: translate(0, -50%);
        }
      }
    }

    .code {
    }

    .checkbox-position {
      .p-position {
        width: auto;
        height: 19px;
      }
      .c-checkbox {
        width: 20px;
        height: auto;
      }
      .c-h {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 0.5vw;
      }
    }
    .btn-b {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 3.5vw;
      gap: 1.7vw;
      img {
        width: 145px;
        height: auto;
      }
    }
  }

  .reg-model {
    position: fixed;

    .cnt {
      position: relative;
      top: 20%;
      left: 50%;
      transform: translate(-50%, 0);
      width: 600px;
      img {
        display: block;
      }
      .close {
        position: absolute;
        top: -80px;
        right: 2vw;
        width: 60px;
        height: auto;
      }
      .p-up {
        width: 600px;
        height: auto;
        margin: 0 auto;
      }
      .p-regcode {
        width: 500px;
        height: auto;
        margin: 0 auto;
      }
    }
    .reg-cnt {
      width: 500px;
    }
  }
}
@media screen and (max-width: 1200px) {
}

@media screen and (min-width: 2000px) and (max-width: 2561px) {
}
</style>



// WEBPACK FOOTER //
// src/components/publicComponents/reg.vue